/**
 * @generated SignedSource<<267af27488408de92413899658c13877>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DiscountDuration = "FIRST_ONLY" | "N_MONTHS" | "RECURRING" | "%future added value";
export type DiscountType = "FIXED" | "PERCENTAGE" | "%future added value";
export type PlanSlug = "BANQUET" | "CHEFS_SPECIAL" | "DEGUSTER" | "GOURMET" | "TWOHDSC" | "%future added value";
export type UpdatePromotionalCodeInput = {
  appliesTo?: ReadonlyArray<PlanSlug> | null;
  code?: string | null;
  discountDuration?: DiscountDuration | null;
  discountType?: DiscountType | null;
  discountValue?: number | null;
  durationMonths?: number | null;
  expiresAt?: any | null;
  id: string;
  isActive?: boolean | null;
  maxUses?: number | null;
};
export type UpdatePromotionalCodeMutation$variables = {
  input: UpdatePromotionalCodeInput;
};
export type UpdatePromotionalCodeMutation$data = {
  readonly UpdatePromotionalCode: {
    readonly appliesTo: ReadonlyArray<PlanSlug>;
    readonly code: string;
    readonly createdAt: any;
    readonly currentUses: number;
    readonly discountDuration: DiscountDuration;
    readonly discountType: DiscountType | null;
    readonly discountValue: number | null;
    readonly durationMonths: number;
    readonly expiresAt: any | null;
    readonly id: string;
    readonly isActive: boolean;
    readonly maxUses: number;
    readonly plan: PlanSlug | null;
    readonly planName: string | null;
    readonly planValueCents: number | null;
  };
};
export type UpdatePromotionalCodeMutation = {
  response: UpdatePromotionalCodeMutation$data;
  variables: UpdatePromotionalCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionalCode",
    "kind": "LinkedField",
    "name": "UpdatePromotionalCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planValueCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountDuration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMonths",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliesTo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePromotionalCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePromotionalCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1d62b7836c5db3354e089b9d1349f43f",
    "id": null,
    "metadata": {},
    "name": "UpdatePromotionalCodeMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePromotionalCodeMutation(\n  $input: UpdatePromotionalCodeInput!\n) {\n  UpdatePromotionalCode(input: $input) {\n    id\n    code\n    plan\n    planName\n    planValueCents\n    discountType\n    discountValue\n    discountDuration\n    durationMonths\n    appliesTo\n    isActive\n    maxUses\n    currentUses\n    expiresAt\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "01bdd33fd964256456881ffef844d02d";

export default node;
